// extracted by mini-css-extract-plugin
module.exports = {"switchToggle":"Switch_switchToggle__Fec0_","isActive":"Switch_isActive__DnGZA"};